import { PlayerBody } from "../defines/enums"
import { EquippableItem, Offset } from "../defines/types"
import { Cabinet } from "./cabinet"

export class GizmoCabinet extends Cabinet {
  constructor(
    offsets: Offset,
    name: string,
    description: string,
    displayFunc: (e: EquippableItem[]) => EquippableItem[][]
  ) {
    super(offsets, name, description, displayFunc)
  }

  prepareToRender(): void {
    const player = window.engine.getPlayer()
    const e = player.getEquipment(PlayerBody.RIGHT_HAND)
    if (e !== undefined && e.twoHanded) {
      this._errorMsg = "Cannot carry a gizmo and a two-handed weapon."
      this._showConfirmDialog = true
    } else {
      this._showConfirmDialog = false
    }

    super.prepareToRender()
  }
}
